import styled from 'styled-components';


const SideBarUl = styled.ul`
    display: block;
    list-style-type: none;
    width: 100%;
    padding: 0px;
    margin: 0px;
    margin-top: ${props => (props.anchorToBottom ? 'auto' : 0)};

    li {
        width: 100%
    }

    li a {
        text-decoration: none;
    }

    li:first-child {
        padding-top: 4px;
    }

`;

export default SideBarUl;



// WEBPACK FOOTER //
// ./src/components/atoms/sidebar/SideBarUl.js